import type { ExtraType, PackType } from "../../../../common-deprecated/types/CommonTypes";
import { useCarConfigSelector } from "../redux/store";
import CarDataConsolidator from "../../../shared-logic/utils/classes/CarDataConsolidator";
import { find } from "../../../../common-deprecated/utils";

const useAphExtra = (
    extra: ExtraType,
): { availablePack?: PackType; includedPackName?: string; isSelected: boolean } => {
    const items = useCarConfigSelector((state) => state.items);

    const basketExtras = useCarConfigSelector((state) => state.basket.extras);
    const basketPacks = useCarConfigSelector((state) => state.basket.packs);

    // Get all the standard included packs
    const standardPacks = items.packs.filter((pack) => pack.standard);

    // Add basket packs and standard included packs together to get all selected packs
    const allPacks = [...basketPacks, ...standardPacks];

    /**
     * Included in packs logic
     */
    // Get the selected pack extras in the basket
    const basketPackExtras = useCarConfigSelector((state) => state.basket.packExtras);

    // Standard packs are not added to the basket but are in fact selected. This is why they are spread below
    const extrasFromSelectedPacks = CarDataConsolidator.getExtrasFromPacks(allPacks, true, false);

    // The extra is already in a selected pack. Pass along the name
    const includedExtra = find(extra.id, extrasFromSelectedPacks) || find(extra.id, basketPackExtras);

    const includedPackName = allPacks.find(
        (pack) => !!pack.equipment.find((equipment) => includedExtra?.id === equipment.id),
    )?.name;

    /**
     * Available in packs logic
     */
    // Get all the standard extras in all packs
    const standardPackExtras = CarDataConsolidator.getExtrasFromPacks(items.packs, true, false);
    // Get all the optional extras in all packs
    const optionalExtrasFromSelectedPacks = CarDataConsolidator.getExtrasFromPacks(allPacks, false, true);
    // The extra is included in a pack when it is a standard extra in any pack and not an optional extra in a selected pack
    const availableExtra = !find(extra.id, optionalExtrasFromSelectedPacks)
        ? find(extra.id, standardPackExtras)
        : undefined;

    const availablePack = items.packs.find(
        (pack) => !!pack.equipment.find((equipment) => availableExtra?.id === equipment.id),
    );

    /**
     * selection logic
     */
    const basketExtra = find(extra.id, basketExtras);

    const isSelected = !!basketExtra || !!includedPackName;

    return {
        availablePack,
        isSelected,
        includedPackName,
    };
};

export default useAphExtra;
